import React from "react";
import './ToggleSwitch.css';

export default function ToggleSwitch(props) {
    function onChange (e) {
        if (props.onChange) {
            props.onChange(e.target.checked);
        }
        return e;
    };

    return (
        <div>
            <div className={"toggle-switch" + (props.small ? " small-switch" : "")}>
                <input
                    type="checkbox"
                    name={props.name}
                    className="toggle-switch-checkbox"
                    data-testid={props.dataTestId}
                    id={props.id}
                    checked={props.checked}
                    onChange={onChange}
                    disabled={props.disabled}
                />
                {props.id ? (
                    <label className="toggle-switch-label" htmlFor={props.id}>
                        <span className={
                                props.disabled
                                ? "toggle-switch-inner toggle-switch-disabled"
                                : "toggle-switch-inner"
                            }
                        />
                        <span className={
                                props.disabled
                                    ? "toggle-switch-switch toggle-switch-disabled"
                                    : "toggle-switch-switch"
                            }
                        />
                    </label>
                ) : null}
            </div>
            <label className="toggle-label" >{props.label}</label>
        </div>
    );
}